<template>
	<modal class="ui ui--loader" v-if="isActive">
		<ElementLoader :label="progressValue ? progressValue + ' %' : ''" />
		<ElementText v-if="packageSyncer.error" :content="packageSyncer.error" />
		<ElementButton
			v-if="packageSyncer.error && isLoaner"
			name="restart"
			@click="restart"
			content="restart app"
		/>
	</modal>
</template>
<script>
import { syncActionStates } from '@/tools/consts';

import { mapState, mapGetters } from 'vuex';
import { mapStateNested } from '@/tools/helpers';
import { getterTypes } from '@/types';

import { uiComponents } from '@/tools/viewState';
import { logger } from '@/tools/logger';
import { appExit } from '@/tools/nativeInterfaceFunctions';
import UiBase from './base.vue';
export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.uiLoader,
		};
	},
	computed: {
		...mapGetters([getterTypes.currentExhibition]),
		...mapState(['viewState', 'styleTemplateURL', 'packageSyncer', 'isLoaner', 'dataSourceCFG']),
		...mapStateNested('packageSyncer', ['packagesProcessed', 'packagesTotal', 'mode', 'subPartStates']),
		label() {
			return this.packageSyncer.error && this.packageSyncer.error !== 'null' ? this.packageSyncer.error : '';
		},
		isActive() {
			let partState;
			if (this.currentExhibition && this.currentExhibition.exhibitionID !== 'root') {
				const exhibitionMode = this.currentExhibition.configWebClient.packageSyncer.mode;
				partState = this.subPartStates[this.currentExhibition.exhibitionID];
				if (
					exhibitionMode === 'all' &&
					(partState === syncActionStates.loading || partState === syncActionStates.loadPending)
				) {
					return true;
				}
			}
			if (this.dataSourceCFG && this.dataSourceCFG.global.isProgressiveWebApp && this.isOpen) return true;
			partState = this.subPartStates[this.mode];
			logger.log('this.mode', this.mode);
			logger.log('partState', partState);
			if (partState === syncActionStates.loading || partState === syncActionStates.loadPending) {
				return true;
			}
			return false;
		},
		progressValue() {
			return Math.round((this.packagesProcessed * 100) / this.packagesTotal);
		},
	},
	methods: {
		restart() {
			logger.log('Restart App after Error occured');
			appExit();
		},
	},
};
</script>
